







import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class NumberTmpl extends Vue {
  @Prop({ default: 0 }) public num!: number;
  @Prop({ default: "€" }) public currency!: string;
  @Prop({ default: true }) public showCurrency!: boolean;
  @Prop({ default: false }) public showPercentage!: boolean;
  @Prop({ default: false }) public isInteger!: boolean;
  @Prop({ default: "" }) public maclass!: string;

  public formatNumber() {
    if (this.num === null) {
      return Number("0").toLocaleString();
    }
    let n = this.num.toFixed(2);
    if (this.isInteger) {
      n = this.num.toFixed(0);
    }
    if (n === "NaN") {
      return Number("0").toLocaleString();
    }
    return Number(n).toLocaleString(undefined, {
      minimumFractionDigits: this.isInteger ? 0 : 2,
    });
  }
}
